import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createComponentGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { RequireProWorkspace } from './components/require-pro-workspace'

function guarded(Page: ComponentType): ComponentType {
  return createComponentGuardedPage(RequireProWorkspace, Page)
}

/** PRO onboarding routes — mirrors Flutter `/home/pro-onboarding`. */
export const proOnboardingRoutes: RouteObject[] = [
  {
    path: 'pro/onboarding',
    lazy: async () => {
      const { ProOnboardingHubPage } = await import('./pages/pro-onboarding-hub-page')
      return { Component: guarded(ProOnboardingHubPage) }
    },
  },
  {
    path: 'pro/onboarding/cases/:caseId',
    lazy: async () => {
      const { ProOnboardingCasePage } = await import('./pages/pro-onboarding-case-page')
      return { Component: guarded(ProOnboardingCasePage) }
    },
  },
  {
    path: 'pro/desk',
    lazy: async () => {
      const { ProDeskAdminPage } = await import('./pages/pro-desk-admin-page')
      return { Component: guarded(ProDeskAdminPage) }
    },
  },
  {
    path: 'pro/onboarding/people/:employeeId',
    lazy: async () => {
      const { ProOnboardingPersonPage } = await import('./pages/pro-onboarding-person-page')
      return { Component: guarded(ProOnboardingPersonPage) }
    },
  },
]
